// نغمات حالة المهمة: شريط علوي + شارة. المكتملة خضراء (ليست حمراء)، المرفوضة حمراء.
export const STATUS_TONE = {
  new: { bar: "bg-sky-500", badge: "bg-sky-500/15 text-sky-700 dark:text-sky-300" },
  in_progress: { bar: "bg-amber-500", badge: "bg-amber-500/15 text-amber-700 dark:text-amber-300" },
  pending_review: { bar: "bg-violet-500", badge: "bg-violet-500/15 text-violet-700 dark:text-violet-300" },
  completed: { bar: "bg-emerald-500", badge: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300" },
  rejected: { bar: "bg-rose-500", badge: "bg-rose-500/15 text-rose-700 dark:text-rose-300" },
  cancelled: { bar: "bg-zinc-400", badge: "bg-zinc-400/15 text-zinc-600 dark:text-zinc-300" },
};

export const PRIORITY_TONE = {
  low: "text-emerald-600",
  medium: "text-sky-600",
  high: "text-amber-600",
  urgent: "text-rose-600",
};
